import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';

import ReviewResponses from '../../Survey/components/ReviewResponses/ReviewResponses';
import {
  CONTENT_TYPE_SURVEY,
  formatContentResponsesRoute,
} from '../../Survey/routes';
import {
  getCurrentContentTypeFromURL,
  getDivestitureDiagnosticResults,
} from './divestitureDiagnosticSlice';
import ResetAnswersRedirect from './ResetAnswersRedirect';
import { CONTENT_TYPE_RESULTS } from './routes';

const ResponsesRouter = () => {
  const { projectId } = useParams();

  const divestitureDiagnosticResults = useSelector(
    getDivestitureDiagnosticResults
  );
  const contentType = useSelector(getCurrentContentTypeFromURL);

  const isSurveyRoute = contentType === CONTENT_TYPE_SURVEY;

  return (
    <>
      <ResetAnswersRedirect />
      {isSurveyRoute && divestitureDiagnosticResults && (
        <Redirect
          to={formatContentResponsesRoute(projectId, CONTENT_TYPE_RESULTS)}
        />
      )}
      {!isSurveyRoute && !divestitureDiagnosticResults && (
        <Redirect
          to={formatContentResponsesRoute(projectId, CONTENT_TYPE_SURVEY)}
        />
      )}
      <ReviewResponses isSurveySubmitted={!!divestitureDiagnosticResults} />
    </>
  );
};

export default ResponsesRouter;
